<template>
  <div>
    <b-card>
      <h4 class="mb-2">
        {{ $t("BankAccount.BankAccount") }}
        <!-- บัญชีธนาคาร -->
        </h4>
      <b-row>
        <b-col cols="12" xl="4" lg="4" md="4">
          <b-card
            style="border: 1px dashed #ebe9f1; border-radius: 8px;"
            v-b-modal.modal-mybank
          >
            <div
              style="
                justify-content: center;
                align-content: center;
                display: flex;
                height: 9rem;
                align-items: center;
              "
            >
              <div style="display: block; height: 3rem;">
                <div class="d-flex" style="justify-content: center;">
                  <span style="color: #bdbdbd;" class="mx-auto">+</span>
                </div>
                <p style="color: #bdbdbd;">
                  {{ $t("BankAccount.AddBankAccount") }}
                  <!-- เพิ่มบัญชีธนาคาร -->
                  </p>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          xl="4"
          lg="4"
          md="4"
          v-for="(item, index) in userData"
          :key="index"
        >
          <b-card
            style="border: 1px solid #ebe9f1; border-radius: 8px; padding: 0;"
            no-body
            v-b-modal.modal-mybank
            @click="handlerOpenModalEdit(item)"
          >
            <div
              style="
                height: 6rem;
                background-color: #bbf1fa;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <p>{{ item.bankName }}</p>
            </div>
            <div style="height: 6rem; padding-left: 2rem; padding-top: 1rem;">
              <p>
                **** {{ item.accountNumber && item.accountNumber.slice(6) }}
              </p>
              <div>
                <p>{{ item.accountName }}</p>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- <div class="d-flex justify-content-center">
        <b-button variant="primary">
          บันทึก
        </b-button>
      </div> -->
    </b-card>


<!-- เพิ่มบัญชีธนาคาร -->
    <b-modal
      id="modal-mybank"
      centered
      :title="$t('BankAccount.AddBankAccount')"
      size="lg"
      ok-only
      ref="modal-mybank"
      @ok="handlerAddBankAccount"
    >
      <validation-observer ref="addBank">
        <b-row>
          <b-col cols="12" xl="9" lg="9" md="9">
            <!-- ชื่อ-นามสกุลตามที่ปรากฏในบัญชีธนาคาร -->
            <b-form-group
              :label="$t('BankAccount.NameSurnameAsItAppearsInTheBankAccount')"
              label-cols="6"
            >
              <b-form-input id="accountName" v-model="accountName" />
            </b-form-group>
            <!-- ชื่อธนาคาร -->
            <b-form-group 
            :label="$t('BankAccount.BankName')"
             label-cols="6">
              <v-select
                v-model="selectedBank"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="optionsBank"
              />
            </b-form-group>
            <!-- เลขที่บัญชี -->
            <b-form-group 
            :label="$t('BankAccount.AccountNumber')"
            label-cols="6">
              <validation-provider
                #default="{ errors }"
                name="accountNumber"
                rules="required|min:10"
              >
                <b-form-input
                  id="accountNumber"
                  v-model="accountNumber"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>

      <!-- <div class="d-flex justify-content-center">
        <b-button variant="primary" @click="handlerAddBankAccount">
          ตกลง
        </b-button>
      </div> -->
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BCardHeader,
  BFormInput,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getUserData } from "@/auth/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min } from "@validations";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    vSelect,
    BCardHeader,
    BFormInput,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    userData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // กรุณาเลือกชื่อธนาคาร
      selectedBank: { title: "กรุณาเลือก" },

      option: [{ title: "Active" }, { title: "Inactive" }],
      accountNumber: "",
      accountName: "",
      required,
      min,
      accountId: "00000000-0000-0000-0000-000000000000",
    };
  },
  setup() {
    const optionsBank = ref([{ value: "", text: "" }]);
    store
      .dispatch("my-bank/getBankList")
      .then((response) => {
        if (response !== null) {
          response.data.data.forEach((data) => {
            optionsBank.value.push({
              value: data.bankId,
              title: data.bankName,
            });
          });
        }
      })
      .catch((error) => {
        this.showToast("danger", "XCircleIcon", error.response.data);
      });

    return {
      optionsBank,
    };
  },
  mounted() {},
  methods: {
    showToast(variant, icon, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon,
          text,
          variant,
        },
      });
    },
    handlerAddBankAccount() {
      this.$refs.addBank.validate().then((success) => {
        if (success) {
          let payload = {
            accountId: this.accountId,
            accountName: this.accountName,
            accountNumber: this.accountNumber,
            bankId: this.selectedBank.value,
            bankName: this.selectedBank.title,
            isDefault: true,
          };
          store
            .dispatch("my-bank/addBankAccount", payload)
            .then((response) => {
              store
                .dispatch("my-bank/getBankAccountList")
                .then((response) => {
                  this.userData = response.data.data;
                })
                .catch((error) => {
                  if (error.response.status === 404) {
                    this.userData = undefined;
                  }
                });
            })
            .catch((error) => {
              console.log("err", error);
            });
        }
      });
    },
    handlerOpenModalEdit(value) {
      this.$refs["modal-mybank"].show();
      this.accountName = value.accountName;
      this.accountId = value.accountId;
      this.accountNumber = value.accountNumber;
      this.selectedBank = {
        value: item.bankId,
        title: item.bankName,
      };
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
